import apiClient from "../core/HttpClient";
import { GreetingOccasionSubcategory } from "../models";

export default class GreetingOccasionSubcategoryService{
    url="/GreetingOccasionSubcategories";

    public async getGreetingOccasionSubcategories(): Promise<GreetingOccasionSubcategory[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getGreetingOccasionSubcategoryById(id: string): Promise<GreetingOccasionSubcategory> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async getGreetingOccasionSubcategoriesByCategoryId(categoryId: number): Promise<GreetingOccasionSubcategory[]> {
        return await apiClient.get(`${this.url}/by-category/${categoryId}`).then((res) => res.data);
    }

    public async createGreetingOccasionSubcategory(greetingOccasionSubcategory: GreetingOccasionSubcategory) {
        return await apiClient.post(this.url, greetingOccasionSubcategory);
    }

    public async updateGreetingOccasionSubcategory(greetingOccasionSubcategory: GreetingOccasionSubcategory) {
        return await apiClient.put(`${this.url}`, greetingOccasionSubcategory);
    }

    public async deleteGreetingOccasionSubcategory(id: number) {
        return await apiClient.delete(`${this.url}/${id}`);
    }
}






















